/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Marcus Biesel <m.biesel@techdivision.com>
 */

import { QueryClient } from '@tanstack/react-query';
import { reactQueryConfig } from '../../Config/Api/ReactQueryConfig';

/**
 * QueryClient
 * @type {QueryClient}
 */
export const queryClient = new QueryClient({
  ...reactQueryConfig,
});
